import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';
import api from 'src/services/api';
import { CUSTOMER_QUERY_KEY, CUSTOMERS_QUERY_KEY } from 'src/constants/query';

export const CUSTOMER_HISTORY_QUERY_KEY = 'customerHistory';

export const updateSubscription = ({ customerId, ...subscription }) =>
  api.put(`customer/${customerId}/subscription`, subscription);

export const useUpdateSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation(updateSubscription, {
    onSuccess: updatedCustomer => {
      // Patch the cached customer directly so the details page reflects the change immediately,
      // and invalidate the list/history views since they hold their own separate cached pages.
      queryClient.setQueryData(CUSTOMER_QUERY_KEY, prevData => ({
        ...prevData,
        ...updatedCustomer,
      }));
      queryClient.invalidateQueries(CUSTOMERS_QUERY_KEY);
      queryClient.invalidateQueries(CUSTOMER_HISTORY_QUERY_KEY);
    },
  });
};

export const getCustomerHistory = ({ customerId, page = 1, limit = 20 }) =>
  api.get(`customer/${customerId}/history`, {
    params: {
      Page: page,
      Limit: limit,
    },
  });

export const useInfiniteCustomerHistory = ({ customerId, limit = 20, enabled = true }) =>
  useInfiniteQuery(
    [CUSTOMER_HISTORY_QUERY_KEY, 'infinite', customerId, limit],
    ({ pageParam = 1 }) => getCustomerHistory({ customerId, page: pageParam, limit }),
    {
      // The endpoint returns a total count alongside the page, but a short page is the one
      // signal that holds whichever way that count is scoped, so page length drives this.
      getNextPageParam: (lastPage, allPages) =>
        (lastPage?.history?.length ?? 0) >= limit ? allPages.length + 1 : undefined,
      enabled: enabled && !!customerId,
    },
  );
